import type { CreativeFormatId } from './creative.js';

/**
 * SAHNE ŞABLONLARININ HERKESE AÇIK YÜZÜ — reçete YOK.
 *
 * ═══════════════════════════════════════════════════════════════════════════
 * 🔴 Bu dosyanın var olma sebebi tek bir şey: prompt tarayıcıya İNMESİN
 * ═══════════════════════════════════════════════════════════════════════════
 * Reçeteler (`prompt`, `slot.auto`, `palette.prompt`) ürünün kendisi. 19 Ağu
 * 2026'ya kadar hepsi `apps/web/src/lib/image-prompt-templates.ts`te duruyordu,
 * yani her ziyaretçinin indirdiği JavaScript paketinin içinde: kaynağı açan
 * ya da `.next/static` altını tarayan biri altı reçetenin tamamını kopyalayıp
 * başka bir araçta kullanabiliyordu.
 *
 * Çözüm bir gizleme değil bir AYRIM: katalog ikiye bölündü.
 *
 *   · Reçete       → `scene-templates.ts`, YALNIZ sunucu (alt yol import'u,
 *                    `index.ts` barrel'ında yok). Worker prompt'u ondan kuruyor.
 *   · Üstveri      → bu dosya. Ad, açıklama, önizleme görseli, metin
 *                    yuvalarının etiketleri. Arayüzün ekranı çizmek için
 *                    ihtiyacı olan HER ŞEY, reçetenin HİÇBİR parçası.
 *
 * Arayüz kataloğu `GET /creatives/studio/options` ile alıyor; şablonu
 * seçtiğinde geriye yalnız KİMLİĞİNİ ve yuvalara yazdığı metni gönderiyor.
 * Reçete sunucuda çözülüyor ve `Creative.inputParams`a da YAZILMIYOR — yani
 * `GET /creatives/:id` yanıtı da onu taşımıyor.
 *
 * ⚠️ Bu tipler barrel'da (`index.ts`) ve olmaları gerekiyor: arayüz uç
 * yanıtını bunlarla okuyor. Barrel'da olmaması gereken şey REÇETE, sözleşme
 * değil.
 */

/**
 * Metin yuvasının arayüz yüzü.
 *
 * `auto` alanı BURADA YOK ve olmaması bilinçli: o alan "kullanıcı boş
 * bırakırsa modele ne söylenecek" yönergesi, yani reçetenin bir parçası.
 * Kullanıcı onu zaten hiç görmüyordu; sözleşmeye koymak, görmediği bir metni
 * yine de indirmesi demekti.
 */
export interface SceneSlotCard {
  key: string;
  label: { tr: string; en: string };
  /// Kutuda gri duran örnek — aynı zamanda beklenen UZUNLUĞU gösteriyor.
  example: { tr: string; en: string };
  max: number;
}

export interface SceneTemplateCard {
  id: string;
  /// `sceneCategories` içindeki bir kimlik.
  category: string;
  name: { tr: string; en: string };
  description: { tr: string; en: string };
  /// `apps/web/public/` altında mutlak yol — şablonun KENDİ reçetesiyle
  /// üretilmiş örnek çıktı.
  preview: string;
  /// Kartta görünen yazı eşleşmesi etiketi (insan okur özet).
  typeface: { tr: string; en: string };
  /// Şablonun tasarım paleti — önizleme bununla üretildi.
  palette: string;
  slots: SceneSlotCard[];
  format: CreativeFormatId | null;
  /**
   * Kartın görsel kutusunun CSS `aspect-ratio` değeri.
   *
   * Formattan TÜRETİLİP gönderiliyor, arayüzde hesaplanmıyor: eşleme tablosu
   * iki yerde durursa yeni bir format eklendiğinde biri sessizce eski kalır
   * ve kart, kurgulandığı orandan başka bir kutuya `cover` ile oturur — yani
   * şablonun tanınmasını sağlayan başlık bloğu kırpılır.
   */
  aspectRatio: string;
}

export interface ScenePaletteCard {
  id: string;
  name: { tr: string; en: string };
  /**
   * Arayüzdeki minik renk örneği — YALNIZ arayüz.
   *
   * Modele giden şey bu hex değil, sunucudaki `palette.prompt` betimlemesi.
   * İkisini tek alanda birleştirmek, kutucuktaki rengin çıktıdaki renk
   * sanılmasına yol açardı; ayrıca betimleme reçetenin parçası olduğu için
   * buraya zaten giremezdi.
   */
  swatch: string;
}

export interface SceneCategoryCard {
  id: string;
  label: { tr: string; en: string };
}
